export default "__VITE_ASSET__FUrVD7I9__"